import React, { useState } from 'react';
import "./footer.css";
import logo from "../../Assets/Images/footer-logo.png";
import hashooGroup from "../../Assets/Images/hashhoGroupLogo.png";
import cdcimg from "../../Assets/Images/CDC-logo.png";
import askari11 from "../../Assets/Images/askari11.png";
import CallIcon from '@mui/icons-material/Call';
import DraftsIcon from '@mui/icons-material/Drafts';
import {
  Container,
  Grid,
  TextField,
  Button,
} from "@mui/material";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import NewsLetter from '../../Components/NewsLetter/NewsLetter';

const Footer = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phoneNumber: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      name: formData.name,
      email: formData.email,
      phoneNumber: formData.phoneNumber,
      message: formData.message,
    };

    try {
      const response = await fetch('YOUR_API_ENDPOINT', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        // Handle successful response
        console.log('Form submitted successfully');
      } else {
        // Handle error response
        console.log('Form submission failed');
      }
    } catch (error) {
      // Handle network errors
      console.error('An error occurred:', error);
    }
  };

  return (
    <>
      <NewsLetter />
      <div className='footer_main_div'>
        <Container sx={{ py: 5 }}>
          <Grid container>
            <Grid item xs={12} md={4}>
              <div className='footer_logo'>
                <img src={logo} alt="img" width={250} />
              </div>
              <div className='logo_sections'>
                <img src={hashooGroup} alt=" " />
                <img src={askari11} alt="" />
                <img src={cdcimg} alt="" />
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
              <div className='footer_section_first'>
                <h4>Quick Links</h4>
                <p> Download Apartment Layouts</p>
                <p>Download Payment Details</p>
              </div>
              <div className='iconText'>
                <CallIcon /> <p>+92 321 411 4611</p>
              </div>
              <div className='iconText'>
                <DraftsIcon /><p>info@pearltowersofficial.com</p>
              </div>
              <div className='iconText'>
                <LocationOnIcon /> <p>Pearl Towers, Rd A, Askari XI, Lahore</p>
              </div>
              <div className='map_div'>
                <div className="google_maps">
                  <iframe
                    src="https://www.google.com/maps/embed?origin=mfe&pb=!1m4!2m1!1spearl+towers+rd+A,+Askari+XI!5e0!6i11"
                    loading="lazy"
                  ></iframe>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
              <div className='footer_section_first'>
                <h4>Get in Touch with us</h4>
                <form onSubmit={handleSubmit}>
                  <Grid container>
                    <Grid item xs={12} md={12}>
                      <TextField
                        hiddenLabel
                        id="filled-hidden-label-small"
                        placeholder="Name"
                        variant="filled"
                        size="small"
                        className="inputFieldother"
                        fullWidth
                        required
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                      <TextField
                        hiddenLabel
                        id="filled-hidden-label-small"
                        placeholder="Email"
                        variant="filled"
                        size="small"
                        className="inputFieldother"
                        fullWidth
                        required
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </Grid>
                    <TextField
                      hiddenLabel
                      id="filled-hidden-label-small"
                      placeholder="Your Phone Number"
                      variant="filled"
                      size="small"
                      className="inputFieldother"
                      fullWidth
                      required
                      name="phoneNumber"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                    />
                    <TextField
                      hiddenLabel
                      id="filled-hidden-label-small"
                      placeholder="Message"
                      variant="filled"
                      size="small"
                      multiline
                      rows={3}
                      fullWidth
                      className="inputFieldother"
                      required
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                    />
                    <Button type="submit" variant="contained" className="submitBtnfooter">
                      Send
                    </Button>
                  </Grid>
                </form>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>
      <div className='footer_last_div'>
        <Container>
          <div className='footer_last_div_section'>
            <p> All Rights Reserved by Pearl Towers Official
              | Privacy Policy |
              Designed and Developed by Xcentric Services.</p>
          </div>
        </Container>
      </div>
    </>
  );
}

export default Footer;
